import { kPositionStatusID, PositionStatus } from "../constants";
import type { QObjDBObject } from "../CoreApp/QObjDBObject";

/**
 * Mirrors the closed-position check in OverrideFactory.ReassignHolder
 * ("You cannot move employees to closed positions."). A position's status
 * field reflects Closed whether it was closed in the base data or via a
 * pending plan override, so this covers both without needing to inspect
 * override state directly.
 */
export function IsPositionClosed(targetObj: QObjDBObject | null | undefined): boolean {
  return targetObj?.SmartGetFieldValue(kPositionStatusID) === PositionStatus.Closed;
}
